import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import schema from './ResetPassword.schema';
import FormLayout from './ResetPassword.layout';
import FormCreator from '../FormCreator';
import { useDispatch } from 'react-redux';
import { resetPasswordAction } from '../../appContainer/actions';
import { ListItemText } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { FormattedMessage } from 'react-intl';
import messages from '../UserProfileMenu/messages';

const initialData = {
  oldPassword: '',
  newPassword: '',
};

export default function ResetPassword() {
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlePasswordReset = formState => {
    dispatch(resetPasswordAction.Request(formState));
    handleClose();
  };

  const changePassword = <FormattedMessage {...messages.changePassword} />;

  return (
    <div>
      <ListItemText onClick={handleClickOpen}>{changePassword}</ListItemText>
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle>
          <Typography variant="h2">{changePassword}</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <FormattedMessage {...messages.changePasswordText} />
          </DialogContentText>
          <FormCreator
            formElements={FormLayout}
            formValues={initialData}
            onSubmit={handlePasswordReset}
            submitButtonTitle={changePassword}
            validationSchema={schema}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
